import { useEffect, useRef } from "react";
import { Text } from "@aidron/aidron-ds";
import { i18n } from "../../../../translate/i18n";

import PropTypes from 'prop-types';

const { t } = i18n;

export function ColumnTitlesRow({ actions, ctx, uiState }) {

  const { setMonthHeaderCellHeight = () => {} } = actions || {};

  const {
    monthColumns,
    defineHierarchyToDisplay,
  } = ctx || {};

  const {
    freezeColumns,
    monthHeaderCellsSpan,
    renderColumnTitleLabel,
    showSalesHistory = false,
    accuracyTable = false,
  } = uiState || {}

  const defineProductsTitleSpan = () => {
    let columnsSpan = defineHierarchyToDisplay().length + 1;
    return columnsSpan;
  };

  const monthRefs = useRef(null);

  const defineMonthColumnRefs = (node, index) => {
    if (!monthRefs.current) monthRefs.current = new Map();
    const map = monthRefs.current;
    if (node) map.set(index, node);
    else map.delete(index);
  };

  const defineLeftCellBorder = (monthIndex) => monthIndex !== 0;

  useEffect(() => {
    const updateDimensions = () => {
      const refsMap = monthRefs.current;
      if (refsMap && refsMap.has(0)) {
        setMonthHeaderCellHeight(refsMap.get(0).getBoundingClientRect().height);
      }
    };

    updateDimensions();

    let timeoutId;
    const observer = new ResizeObserver(() => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(updateDimensions, 100);
    });

    const refsMap = monthRefs.current;
    if (refsMap) {
      refsMap.forEach(node => observer.observe(node));
    }

    return () => {
      clearTimeout(timeoutId);
      if (refsMap) {
        refsMap.forEach(node => observer.unobserve(node));
      }
      observer.disconnect();
    };
  }, [monthColumns]);

  return (
    <tr>
      <th
        colSpan={defineProductsTitleSpan()}
        rowSpan={1}
        className={`background-color-white vertical-align-baseline position-sticky z-5 first-row ${
          freezeColumns ? "right-border-fade" : "cell-right-border"
        }`}
        style={{ left: freezeColumns ? "0" : "" }}
      >
        {defineHierarchyToDisplay().length && 
          (
            <Text className="text-center font-size-16px">{t("products")}</Text>
          )
        }
      </th>

      {showSalesHistory && (
        <th colSpan={6} className="text-center z-1">
          <Text className="font-size-16px">{t("salesHistory")}</Text>
        </th>
      )}

      {monthColumns.map((month, index) => (
        <th
          colSpan={monthHeaderCellsSpan}
          className={`text-center vertical-align-baseline month-cells position-sticky z-3 
            ${defineLeftCellBorder(index) ? "cell-left-border" : ""} pb-0`}
          ref={node => defineMonthColumnRefs(node, index)}
          key={accuracyTable
            ? `forecast-${month.forecastId}-month-${month.month}`
            : `forecast-${month.predictionId}-month-${month.month}-product-${month.productId}`
          }
        >
          {renderColumnTitleLabel(month)}
        </th>
      ))}
    </tr>
  );
};

ColumnTitlesRow.propTypes = {
  actions: PropTypes.shape(),
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
};